import React from "react";

const CategoryDropdownPosition = ({ selectHandler, elValue, positions }) => {
  let types = positions;
  
  return (
    <div className="relative w-full sm:w-48">
      <select 
        value={elValue} 
        name="Type" 
        id="Type" 
        className="w-full text-left py-2 pl-3 pr-8 text-sm sm:text-base bg-white border border-gray-300 rounded-lg 
                  shadow-sm outline-none appearance-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200
                  hover:border-gray-400 transition-colors duration-200 cursor-pointer"
        onChange={selectHandler}
      >
        {types.map((type, i) => (
          <option value={type} key={type}>
            {type}
          </option>
        ))}
      </select>
      
      {/* Custom dropdown arrow */}
      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500">
        <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </div>
    </div>
  );
}

export default CategoryDropdownPosition;